var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBillingDetails = function SvgBillingDetails(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "billing_details_svg2__a",
    x1: 20.31,
    x2: 161.76,
    y1: 26.52,
    y2: 201.42,
    gradientTransform: "matrix(1 0 0 -1 0 200)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a70095"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "billing_details_svg2__c",
    x1: -15.86,
    x2: 125.59,
    y1: 55.78,
    y2: 230.67,
    gradientTransform: "matrix(1 0 0 -1 0 200)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a70095"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "billing_details_svg2__d",
    x1: 4.7,
    x2: 146.14,
    y1: 39.15,
    y2: 214.05,
    gradientTransform: "matrix(1 0 0 -1 0 200)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a70095"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "billing_details_svg2__e",
    x1: 8.18,
    x2: 149.63,
    y1: 36.33,
    y2: 211.23,
    gradientTransform: "matrix(1 0 0 -1 0 200)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a70095"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "billing_details_svg2__f",
    x1: 28.74,
    x2: 170.18,
    y1: 19.71,
    y2: 194.6,
    gradientTransform: "matrix(1 0 0 -1 0 200)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a70095"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "billing_details_svg2__g",
    x1: 32.22,
    x2: 173.67,
    y1: 16.89,
    y2: 191.78,
    gradientTransform: "matrix(1 0 0 -1 0 200)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a70095"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M140.04 194.89c2.67-.93 4.4-3.35 4.4-6.18V96.07h34.62c7.45 0 13.51-6.06 13.51-13.51V26.8c0-14.94-12.15-27.09-27.09-27.09H35.99C20.41-.29 7.73 12.38 7.73 27.96v160.77c0 2.82 1.72 5.25 4.39 6.18s5.52.09 7.27-2.13l7.34-9.31c.09-.12.22-.18.38-.18s.28.06.37.18l10.83 13.75c1.25 1.58 3.12 2.49 5.13 2.49s3.88-.91 5.13-2.49l10.82-13.74a.48.48 0 0 1 .75 0l10.82 13.74c2.49 3.17 7.77 3.17 10.27 0l10.82-13.74c.1-.12.22-.18.38-.18s.28.06.37.18l10.82 13.74c2.5 3.16 7.77 3.16 10.27 0l10.82-13.74c.19-.24.56-.25.75 0l7.31 9.28c1.75 2.22 4.61 3.06 7.28 2.13zM186.5 26.8v55.77c0 4.11-3.34 7.45-7.45 7.45h-34.62V26.8c0-11.6 9.43-21.03 21.03-21.03s21.03 9.44 21.03 21.03Zm-66.55 152.93-10.82 13.74a.48.48 0 0 1-.75 0l-10.82-13.74a6.51 6.51 0 0 0-5.13-2.49c-2.02 0-3.88.91-5.13 2.49l-10.82 13.74a.48.48 0 0 1-.75 0l-10.82-13.74c-2.49-3.17-7.77-3.17-10.27 0l-10.82 13.74a.48.48 0 0 1-.75 0l-10.83-13.75c-1.25-1.58-3.12-2.49-5.13-2.49s-3.88.91-5.13 2.49l-7.34 9.31c-.07.09-.21.27-.53.15-.32-.11-.32-.34-.32-.45V27.96c0-12.24 9.95-22.19 22.19-22.19h112.44c-6.12 4.97-10.05 12.55-10.05 21.03v161.92c0 .11 0 .34-.32.45s-.46-.07-.53-.15l-7.31-9.28c-2.49-3.16-7.77-3.17-10.27 0Z",
    style: {
      fill: "url(#billing_details_svg2__a)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.99 50.92h52.13c1.67 0 3.03-1.36 3.03-3.03s-1.36-3.03-3.03-3.03H35.99c-1.67 0-3.03 1.36-3.03 3.03s1.35 3.03 3.03 3.03",
    style: {
      fill: "url(#billing_details_svg2__c)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.35 69.45H35.99c-1.67 0-3.03 1.36-3.03 3.03s1.36 3.03 3.03 3.03h80.36c1.67 0 3.03-1.36 3.03-3.03s-1.36-3.03-3.03-3.03",
    style: {
      fill: "url(#billing_details_svg2__d)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.99 100.09h52.13c1.67 0 3.03-1.36 3.03-3.03s-1.36-3.03-3.03-3.03H35.99c-1.67 0-3.03 1.36-3.03 3.03s1.35 3.03 3.03 3.03",
    style: {
      fill: "url(#billing_details_svg2__e)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.35 118.61H35.99c-1.67 0-3.03 1.36-3.03 3.03s1.36 3.03 3.03 3.03h80.36c1.67 0 3.03-1.36 3.03-3.03s-1.36-3.03-3.03-3.03",
    style: {
      fill: "url(#billing_details_svg2__f)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.12 143.2H35.99c-1.67 0-3.03 1.36-3.03 3.03s1.36 3.03 3.03 3.03h52.13c1.67 0 3.03-1.36 3.03-3.03s-1.36-3.03-3.03-3.03",
    style: {
      fill: "url(#billing_details_svg2__g)",
      strokeWidth: 0
    }
  }));
};
export default SvgBillingDetails;